var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:17.8929;stroke-miterlimit:10;}\n\t.st1{opacity:0.3;fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "732.54,618.47 730.29,619.6 624.26,673.7 515.02,729.36 400.48,787.86 400,788 344.18,759.53  293.65,733.75 237.02,704.86 129.7,650.19 19.5,593.96 19.5,481.37 129.7,536.46 237.02,590.14 344.18,643.82 403.53,673.56  404.17,673.84 510.04,616.48 509.88,616.34 344.18,533.49 237.02,479.81 129.7,426.13 19.5,371.04 19.5,206.04 75.48,177.43  129.7,149.81 129.7,316.79 237.02,370.47 344.18,424.15 614.79,559.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "344.18,147.54 344.18,205.19 780.5,425.14 780.5,530.37 722.59,501.34 344.18,311.98 237.02,258.3  237.02,95.14 295.25,65.4 344.18,40.47 399.52,12.28 400,12 515.5,70.92 780.5,206.04 780.5,314.81 406.74,122.76 403.53,121.06  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "780.5,206.04 780.5,314.81 406.74,122.76 399.52,12.28 400,12 515.5,70.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "780.5,425.14 780.5,530.37 722.59,501.34 344.18,311.98 237.02,258.3 237.02,253.77 344.18,205.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "732.54,618.47 730.29,619.6 509.88,616.34 344.18,533.49 237.02,479.81 129.7,426.13 19.5,371.04  19.5,370.47 129.7,314.81 129.7,316.79 237.02,370.47 344.18,424.15 614.79,559.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "403.53,673.56 400.48,787.86 400,788 344.18,759.53 293.65,733.75 237.02,704.86 129.7,650.19  19.5,593.96 19.5,481.37 129.7,536.46 237.02,590.14 344.18,643.82  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.50a02609e91725e7785f79c8d343798d.svg";
export { ForwardRef as ReactComponent };